import type { ReactNode } from 'react';

import type { GroupProps } from '@mantine/core';
import { Group, Text } from '@mantine/core';

import { getSx } from '../../../../../../../../shared/utils/sx';
import { usePillsVariant } from './hooks/usePillsVariant';

type Variant = 'light';
type Color = 'blue' | 'red' | 'green' | 'orange' | 'gray' | 'yellow';

interface PillsProps extends GroupProps {
  variant?: Variant;
  color?: Color;
  customColor?: string;
  children?: ReactNode;
  shape?: 'square' | 'round';
  startContent?: ReactNode;
  endContent?: ReactNode;
  onClick?: () => void;
}

export function Pills({
  variant = 'light',
  color = 'gray',
  sx: sxProp = [],
  children,
  shape = 'square',
  startContent,
  endContent,
  customColor,
  onClick,
  ...groupProps
}: PillsProps) {
  const { sx: colorSx } = usePillsVariant({ variant, color, customColor });

  return (
    <Group
      px="02"
      spacing={'01'}
      w="fit-content"
      onClick={onClick}
      sx={[
        colorSx,
        theme => ({
          borderRadius: shape === 'square' ? theme.radius.sm : 100,
          cursor: onClick ? 'pointer' : 'default',
          boxShadow: theme.shadows.xs,
        }),
        ...getSx(sxProp),
      ]}
      {...groupProps}
    >
      {startContent}
      <Text size="xs" fw={600} sx={{ color: 'inherit' }}>
        {children}
      </Text>
      {endContent}
    </Group>
  );
}
